import React, { useEffect, useState } from 'react';
import SETTINGS from '../../SETTINGS';
import { getSubdomain } from '../../utils/utils';
import { downloadAletaInvoicePdf, fetchAletaPaymentReminder } from '../quotes/aleta-billing/api';
import './PaymentReminderBanner.css';

const MONTHS_CA = ['de gener', 'de febrer', 'de març', 'd’abril', 'de maig', 'de juny', 'de juliol', 'd’agost', 'de setembre', 'd’octubre', 'de novembre', 'de desembre'];

// "la factura de l'Aleta d'aquest any", "… de novembre" or "les 2 factures de l'Aleta"
export function describeInvoices(reminder) {
    const { invoices, billingCadence } = reminder;
    if (invoices.length > 1) {
        return `les ${invoices.length} factures de l'Aleta`;
    }
    const month = Number(String(invoices[0].periodStart || '').split('-')[1]);
    return billingCadence === 'monthly' && month
        ? `la factura de l'Aleta ${MONTHS_CA[month - 1]}`
        : 'la factura de l\'Aleta d\'aquest any';
}

function isJuntaMember(userInfo) {
    return parseInt(userInfo?.es_junta || 0, 10) >= 1;
}

// The backend issues the colla's Aleta invoice when its payment month starts;
// the junta sees this banner until the invoice is marked paid (`billing.py paid`).
function PaymentReminderBanner({ isLogged, userInfo, userId }) {
    const colla = getSubdomain();
    const isJunta = isJuntaMember(userInfo);
    const [reminder, setReminder] = useState(null);
    const [downloading, setDownloading] = useState(false);
    const [downloadError, setDownloadError] = useState(null);

    useEffect(() => {
        if (isLogged !== true || !isJunta || !userId) {
            setReminder(null);
            return undefined;
        }

        let cancelled = false;
        fetchAletaPaymentReminder(userId)
            .then(payload => {
                if (!cancelled) {
                    setReminder(payload?.reminder || null);
                }
            })
            .catch(() => {
                if (!cancelled) {
                    setReminder(null);
                }
            });

        return () => {
            cancelled = true;
        };
    }, [isLogged, isJunta, userId]);

    if (isLogged !== true || !isJunta || !reminder?.invoices?.length) {
        return null;
    }

    const collaColor = SETTINGS(colla).color;
    const { invoices } = reminder;
    const isPlural = invoices.length > 1;

    const handleDownload = async (event) => {
        event.preventDefault();
        if (downloading) {
            return;
        }
        setDownloading(true);
        setDownloadError(null);
        try {
            for (const invoice of invoices) {
                await downloadAletaInvoicePdf({ userId, invoiceNumber: invoice.invoiceNumber });
            }
        } catch (error) {
            setDownloadError(error.message || 'No s\'ha pogut descarregar.');
        } finally {
            setDownloading(false);
        }
    };

    return (
        <div className="payment-reminder-banner" role="status">
            <p className="payment-reminder-banner-text">
                {isPlural ? 'Teniu pendents de pagar' : 'Teniu pendent de pagar'}
                {' '}
                <a href="#descarregar-factura" onClick={handleDownload} aria-busy={downloading} style={{ color: collaColor }}>
                    {describeInvoices(reminder)}
                </a>
                . Si ja {isPlural ? 'estan pagades' : 'està pagada'}, digueu-m&apos;ho i ho apunto. Gràcies!
                {downloadError ? <span className="payment-reminder-banner-error"> {downloadError}</span> : null}
            </p>
        </div>
    );
}

export default PaymentReminderBanner;
